import dbCompare from "../";


const routes = [
    {name: "DB Compare", path: "/dbcompare", component: dbCompare.dbCompareListPage, meta: {title: "DB Compare"}},
];
export default routes;